import { navLinks, site, topics } from "@/mocks/chiagua";

export default function Footer() {
  return (
    <footer className="bg-background-200/60">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-[1.3fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-community-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-2xl text-foreground-950">{site.brand}</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              {site.tagline}。每天蹲守评论区，为你打捞神评论、名场面和吃瓜梗图，让快乐随吃随取。
            </p>
            <div className="mt-5 flex gap-2">
              {["ri-tiktok-fill", "ri-wechat-line", "ri-weibo-line", "ri-more-fill"].map((ic, i) => (
                <a
                  key={i}
                  href="#top"
                  aria-label="社交入口"
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={ic} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="快速导航">
            <h3 className="text-sm font-black text-foreground-950">快速浏览</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks
                .filter((n) => n.id !== "top")
                .map((n) => (
                  <li key={n.id}>
                    <a href={`#${n.id}`} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                      {n.label}
                    </a>
                  </li>
                ))}
            </ul>
          </nav>

          <div>
            <h3 className="text-sm font-black text-foreground-950">热门专区</h3>
            <ul className="mt-4 space-y-2.5">
              {topics.map((t) => (
                <li key={t.id}>
                  <a href="#scenes" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {t.name}
                  </a>
                </li>
              ))}
              <li>
                <a href="#contact" className="text-sm font-bold text-accent-700 hover:underline">
                  投稿你的神评 →
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-300/70 pt-6 text-xs leading-relaxed text-foreground-500">
          <p>
            {site.brand} 是面向吃瓜爱好者的内容集合与交流社区。站内整理的神评论、名场面及梗图素材均来源于公开平台，版权归原作者所有，本站仅作收集展示与同好交流，不构成商业授权。
          </p>
          <p className="mt-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <span>
              © {new Date().getFullYear()} {site.brand} · 快乐免费，随时开啃
            </span>
            <a href={`mailto:${site.mail}`} className="flex items-center gap-1 hover:text-primary-600">
              <i className="ri-mail-line" aria-hidden="true"></i> {site.mail}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}